var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"cloudIframe","width":"100%","height":"100%","frameborder":"0","scrolling":"no","src":"cloud/cloud.html"}})
}
var staticRenderFns = []

export { render, staticRenderFns }